// extracted by mini-css-extract-plugin
module.exports = {"leftSearchBar":"styles_leftSearchBar__XYxaR","hotelName":"styles_hotelName__31Z0m","searchButton":"styles_searchButton__3dsRN"};